// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const LocationPin: React.FC<{ width?: number; height?: number }> = ({ width = 12, height = 16 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 12 16">
            <path
                fill="currentColor"
                d="M1.5 5.875c0-2.394 2-4.383 4.5-4.383s4.5 1.99 4.5 4.383c0 1.398-.75 3.14-1.844 4.88C7.781 12.153 6.75 13.397 6 14.236c-.75-.84-1.781-2.083-2.656-3.481C2.25 9.015 1.5 7.273 1.5 5.875ZM6 0C2.687 0 0 2.611 0 5.875c0 3.699 3.75 8.143 5.313 9.822a.931.931 0 0 0 1.375 0C8.25 14.018 12 9.574 12 5.875 12 2.61 9.312 0 6 0ZM5 5.968c0-.56.438-.995 1-.995.563 0 1 .435 1 .995s-.438.995-1 .995c-.563 0-1-.436-1-.995Zm3.5 0a2.5 2.5 0 0 0-5 0 2.5 2.5 0 0 0 5 0Z"
            />
        </svg>
    );
};

export default React.memo(LocationPin);
